// src/project/data/triggers/payProductPurchase.js
// Endpoint: POST /queue/broadcast/data/rapidoo-transactions/productPaymentRequest?group=commons
import { RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'

export default {
  postUrl() {
    // L'URL est absolue (broadcast queue), on la retourne directement
    return RIDER_ENDPOINTS.PRODUCT_PAY
  },
  format(params) {
    const userId = getUserId()
    const userData = Storage.get('userData')
    const walletId = `wallet_${userId}`

    const base = {
      id: `trx_product_${Date.now()}`,
      requestId: `req_product_${Date.now()}`,
      productId: params.productId,
      buyingId: params.buyingId,
      countryCode: params.countryCode || 'BJ',
      currency: 'XOF',
      // walletId du livreur (source de paiement)
      walletId,
      restaurantId: params.restaurantId || userId,
    }

    if (params.paymentMethod === 'wallet' || params.srcType === 'wallet') {
      // Paiement via wallet interne
      return { ...base, srcType: 'wallet' }
    } else {
      // Paiement via Mobile Money
      return {
        ...base,
        srcType: 'momo',
        phoneNumber: params.phoneNumber || userData?.phone || '',
      }
    }
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors du paiement',
        data: null,
        isDisplayable: raw?.isDisplayable || false,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Paiement initié avec succès',
      data: raw?.data || raw,
    }
  },
}
